import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { List } from 'immutable';
import { Subject } from 'rxjs';
import { DialogActionsEnum, IDialogTrigger } from '../../../dialog/dialog.data';
import { DialogService } from '../../../dialog/dialog.service';
import { NavigationService } from '../../../navigation/navigation.service';
import { ICheckmarkItem } from '../../../shared/components/checkmark-list/checkmark-list.component';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-common-payments-dialog',
  templateUrl: './common-payments-dialog.component.html',
  styleUrls: ['./common-payments-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonPaymentsDialogComponent implements OnInit, OnDestroy {
  @Input() dialogType: string = 'common-payments-dialog';
  @Input() confirmLabel: string;
  @Input() confirmUrl: string;
  @Input() confirmInNewWindow: boolean;
  @Input() description: string;
  @Input() headerLabel: string;
  @Input() importantNote: string;
  @Input() learnMoreUrl: string;
  @Input() listItems: List<ICheckmarkItem>;
  @Input() secondaryButtonText: string;
  @Input() tip: string;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() primaryActionTapped: ITrackingAction;
  @Input() secondaryActionTapped: ITrackingAction;
  @Input() dismissActionTapped: ITrackingAction;

  @Output() onConfirm: EventEmitter<void> = new EventEmitter<void>();
  @Output() onSecondaryAction: EventEmitter<void> = new EventEmitter<void>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();

  private _destroyed: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _dialogService: DialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _navigationService: NavigationService
  ) {}

  ngOnInit() {
    this._dialogService.dialogTriggers$
      .pipe(
        filter((dialogTrigger: IDialogTrigger) => {
          return (
            dialogTrigger.type === this.dialogType &&
            dialogTrigger.action === DialogActionsEnum.open
          );
        }),
        takeUntil(this._destroyed)
      )
      .subscribe(() => {
        this._changeDetectorRef.markForCheck();
        this._changeDetectorRef.detectChanges();
      });
  }

  onConfirmDialog() {
    this.onConfirm.emit();

    this._navigationService.goToExternalUrl(
      this.confirmUrl,
      this.confirmInNewWindow
    );
  }

  onLearnMore() {
    this._navigationService.goToExternalUrl(this.learnMoreUrl, true);
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
